import { Box } from '@cast/design-system';
import { ReliabilityDailyDetailsTable } from '@cast/split-me/features/cluster/cost-report';
import { FailedToLoad } from '@cast/shared-messages-ui';

import { inventoryWorkloadTableKeys, tableCacheKeys } from '../../consts';

import { DateRangeUnsupportedBanner } from '../dashboard/_components/DateRangeUnsupportedBanner';
import { useInventoryWorkloadsTimeRangeSelection } from '../../_hooks/useInventoryWorkloadsTimeRangeSelection';
import { useInventoryWorkloadReliabilityData } from './_hooks';

export const InventoryWorkloadListReliability = () => {
  const { data, isLoading, error, isRangeSupported } =
    useInventoryWorkloadReliabilityData();
  const { timeZone } = useInventoryWorkloadsTimeRangeSelection();

  if (!isRangeSupported) {
    return (
      <Box mt={24}>
        <DateRangeUnsupportedBanner testId="inventory-workload-reliability-unsupported-range" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={24}>
        <FailedToLoad title="Failed to load workload reliability details" />
      </Box>
    );
  }

  return (
    <ReliabilityDailyDetailsTable
      data={data}
      timezone={timeZone}
      isLoading={isLoading}
      cacheKey={tableCacheKeys.INVENTORY_WORKLOAD.RELIABILITY}
      urlKey={inventoryWorkloadTableKeys.RELIABILITY}
      testId="inventory-workload-reliability-table"
    />
  );
};
